import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PochtaTariffDto } from './PochtaTariffDto'
import { PochtaTariffDeliveryTimeDto } from './PochtaTariffDeliveryTimeDto'
/**
* Class PochtaTariffCalculationResultDto
*  Ответ калькулятора с учётом Extra* канала (если применялись). Суммы — в копейках, как в API Отправка.
*/
export class PochtaTariffCalculationResultDto extends ActiveModel {

  /**
  * carrierTariff
  * Ответ ПР без Extra*.  */
  @ActiveField({
    factory: [PochtaTariffDto, () => PochtaTariffDto.create()]
  })
  carrierTariff: PochtaTariffDto = PochtaTariffDto.create()


  /**
  * totalRateKopecks
  * Итоговая сумма пересылки с ExtraDeliveryCost (коп.).  */
  @ActiveField()
  totalRateKopecks?: null | number


  /**
  * deliveryTime
  * Сроки с ExtraDeliveryDays.  */
  @ActiveField({
    factory: [PochtaTariffDeliveryTimeDto, () => undefined]
  })
  deliveryTime?: null | PochtaTariffDeliveryTimeDto


  /**
  * extraDeliveryDays
  *   */
  @ActiveField()
  extraDeliveryDays?: number


  /**
  * extraDeliveryCost
  *   */
  @ActiveField()
  extraDeliveryCost?: number
}
